// extracted by mini-css-extract-plugin
module.exports = {"price-range-slider":"PriceSlider_price-range-slider__YGL4k","min-max-price-text":"PriceSlider_min-max-price-text__qC8fm"};